export const getDefaultWidgetState = () => {
    return {
        widgetId: 0,
        chief: 0,
        login: "",
        bonuses: 0,
        isFree: 0,
        isCheck: 0,
        isBusiness: 0,
        isPartnerCalc: false,
        licenseAgreement: false,
        settings: {
            hideAdditionalParams: undefined,
            hideBaseContacts: undefined,
            hideSelectedPrograms: undefined,
            hideChecks: undefined,
            hideDigest: undefined,
            hideFirstStage: undefined,
            hideSecondStage: undefined,
            hideThirdStage: undefined,
            showInsurance: undefined,
            showAboutBanks: undefined,
        },
        userToken: undefined,
        participants: [],
        widgetSetting: {
            logo: undefined,
            partnerCalcConditions: [],
            colors: {
                colorMain: undefined,
                colorMainHover: undefined,
                colorAccent: undefined,
                colorAccentHover: undefined
            }
        }
    };
};
export const state = getDefaultWidgetState();
